import React from 'react'
import InputForm from '../../../components/Input/InputForm'
import { withStyles } from '@material-ui/core'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'

const FormularioMedidas = observer(({classes,exameStore}) => {

    const handleChange = (event, field) => {
    exameStore.changeDadosExame(event, field)
  }

  return (
    <div>
      <div className={classes.content}>
            <div>
              <label className={classes.label}>Altura(cm)*</label>
              <InputForm 
              id="pac-fmd-inp-alt"
              type="number" classes={{ input: classes.input }} 
              onChange={e => handleChange(e?.target?.value, 'altura')}
              value={exameStore?.exame?.altura}
              />
            </div>
            <div>
              <label className={classes.label}>Peso(kg)*</label>
              <InputForm 
               id="pac-fmd-inp-pes"
               classes={{ input: classes.input }} 
               onChange={e => handleChange(e?.target?.value, 'peso')}
               value={exameStore?.exame?.peso}
               />
            </div>
            <div>
              <label className={classes.label}>Volume*</label>
              <InputForm 
              id="pac-fmd-inp-vol"
              classes={{ input: classes.input }}
              onChange={e => handleChange(e?.target?.value, 'volume')}
              value={exameStore?.exame?.volume}
              />
            </div>
          </div>
    </div>
  )
});

const styles = {
  content: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "9px",
    alignItems: "end",
    paddingTop: "10px",
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#505050",
  },
  label: {
    fontSize: "10px",
    color: "#868686",
  },
};


const FormularioMedidasWithStyles = withStyles(styles)(FormularioMedidas)
const stores = ['exameStore']

export default inject(...stores)(FormularioMedidasWithStyles)
